import Vue from 'vue'
import ImagePic from './ImagePic'
import BackTop from './BackTop'
import NavBar from './NavBar'

// 注册一些常用的组件到全局
Vue.component('image-pic', ImagePic)
Vue.component('back-top', BackTop)
Vue.component('nav-bar', NavBar)
